import React, { useEffect } from "react";
import { Button, Form, Input, Space } from "antd";
import "./edit_table_wh_transfer_out.css";

interface EditTableProps {
    initialValues: any;
    showLocationModal: () => void;
    onFinish: (values: any) => void;
    onCancel: () => void;
}

const EditTableWhTransOut: React.FC<EditTableProps> = ({ initialValues, showLocationModal, onFinish, onCancel }) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const [form] = Form.useForm();

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }
    }, [initialValues, form]);

    return (

        <div id="iiok" style={transformStyle}>
            <div className="gjs-grid-row" id="ih04">
                <div className="gjs-grid-column" id="i9vi">
                    <Form
                        layout="horizontal"
                        style={{ maxWidth: 430 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            label="Item Code"
                            name="itemNumber"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="Item Name"
                            name="itemName"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="UoM"
                            name="uom"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="Location Code"
                            style={{ marginBottom: "5px", width: "430px" }}
                        >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Form.Item
                                    name="locationCode"
                                    noStyle
                                    style={{ width: "100%" }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Required!',
                                        },
                                    ]}
                                >
                                    <Input
                                        style={{ width: "100%" }}
                                        readOnly
                                    />
                                </Form.Item>
                                <Button
                                    type="primary"
                                    id="location_code_rack"
                                    onClick={showLocationModal}
                                    icon={
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Qty Available"
                            name="qtyAvailable"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="Qty Request"
                            name="qtyRequest"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled />
                        </Form.Item>
                        <Form.Item
                            label="Qty Out"
                            name="qtyOut"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                                ({ getFieldValue }) => ({ 
                                    validator(_, value) { 
                                        const qtyRequest = Number(getFieldValue('qtyRequest')); 
                                        const qtyOutValue = Number(value); 
                                        if (!value || qtyRequest >= qtyOutValue) { 
                                            return Promise.resolve(); 
                                        } 
                                        return Promise.reject(new Error('Qty Out cannot exceed Qty Request!')); 
                                    }, 
                                }), 
                            ]}
                        >
                            <Input placeholder="" type="number" />
                        </Form.Item>
                        <Form.Item wrapperCol={{ offset: 10, span: 14 }} style={{ paddingTop: "10px" }}>
                            <Space>
                                <Button type="primary" htmlType="submit">
                                    OK
                                </Button>
                                <Button onClick={onCancel}>
                                    Cancel
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>

                </div>
            </div>
        </div>
    );
};

export default EditTableWhTransOut;
